(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("hyPushState", [], factory);
	else if(typeof exports === 'object')
		exports["hyPushState"] = factory();
	else
		root["hyPushState"] = factory();
})(window, function() {
return 